import { Injectable } from '@angular/core';
import { ThemeActionsService } from './theme-actions.service';
import { VIDEO_TARGET, VideoOverlayService } from '@shared/components/video-overlay/video-overlay.service';
import { IoService } from '@core/services/io.service';

@Injectable({
  providedIn: 'root',
})
export class ThinMintActionsService extends ThemeActionsService {
  constructor(private videoOverlayService: VideoOverlayService, private ioService: IoService) {
    super();
    this.setThemeId('thin-mint');
  }

  public override triggerConversationStartActions(callback: Function) {
    this.videoOverlayService.startVideoOverlay({
      src: './../../../../assets/videos/thin-mint.webm',
      targetId: VIDEO_TARGET.Global,
      callback: callback,
    });
  }
}
